export const getMenuTitleByPath = (path: string): string => {
  for (const [title, pathList] of Object.entries(MENU_PATH_GROUPS)) {
    if (pathList.includes(path)) {
      return title;
    }
  }
  return '';
};

export const MENU_PATH_GROUPS: Record<string, string[]> = {
  '메뉴 관리': [
    '/product/list',
    '/product/category', // 메뉴관리 > 카테고리 정보 수정/추가
    '/product/info', // 메뉴관리 > 메뉴 상세 정보
    '/product/form', // 메뉴관리 > 메뉴 추가, 정보 수정
    '/product/connect', // 메뉴관리 > 옵션 연결
    '/product/status', // 메뉴관리 > 메뉴 노출 · 품절 설정
    '/product/sort', // 메뉴순서 > 카테고리/메뉴/옵션 그룹 순서 수정
    '/product/option', // 옵션관리 > 옵션추가, 선택 가능 옵션 수량 설정, 옵션그룹명 추가, 옵션그룹 추가
    '/product/option-status', // 옵션관리 > 옵션 노출 · 품절 설정, 옵션그룹 노출 설정
    '/product/option-sort', // 옵션관리 > 옵션 순서 설정
    '/product/option-unconnect', // 옵션관리 > 연결 메뉴 모두 해제
    '/product/option-name', // 옵션관리 > 옵션명 및 가격 수정, 옵션 그룹명 수정
    '/product/recommend', // 추천메뉴 > 추천 메뉴 선택
  ],
};
